'use client';

import { useState } from 'react';

export const useDraftOnOpen = <TValue>({
  open,
  value,
}: {
  open: boolean;
  value: TValue;
}) => {
  const [draft, setDraft] = useState<TValue>(value);
  const [wasOpen, setWasOpen] = useState(open);

  if (open !== wasOpen) {
    setWasOpen(open);

    if (open) {
      setDraft(value);
    }
  }

  return [draft, setDraft] as const;
};
